<script>
  // Media thumbnail (images/video posters). `value` is the URL. Square with
  // aspect-fit (object-contain) so the full photo is visible, and click-to-preview
  // via the lightbox. Grid card figures set `column.fill` to stretch the thumb to
  // the card's square instead of the fixed table size.
  import ClickableImage from '../../lightbox/clickable_image.svelte'

  let { value, column = {} } = $props()

  const thumbClass = $derived(
    column.fill ? 'h-full w-full object-contain' : 'h-14 w-14 object-contain bg-base-200 rounded-box'
  )
</script>

<ClickableImage url={value} title={column.alt || ''} {thumbClass} buttonClass={column.fill ? 'h-full w-full' : ''} />
